export default __webpack_public_path__ + "static/pd-screen-f5d3f874d59a0b358118cecac2003a56.webp";